import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILED,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  FETCH_ALL_USERS_STATIC,
  FETCH_ALL_USERS_STATIC_SUCCESS,
  FETCH_ALL_USERS_STATIC_FAILED,
  USER_DELETED,
  FETCH_ALL_DRIVERS,
  FETCH_ALL_DRIVERS_SUCCESS,
  FETCH_ALL_DRIVERS_FAILED
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, update, off, get, remove } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { signOut } from "firebase/auth";
import store from '../store/store';

const truthyStatusValues = ["true", "1", "yes", "active", "approved", "enabled", "on"];
const inactiveStatusValues = ["false", "0", "no", "inactive", "disabled", "off", "blocked", "suspended", "deleted"];

const isTruthyStatus = (value) => {
  if (value === true || value === 1) return true;
  if (typeof value === "string") return truthyStatusValues.includes(value.trim().toLowerCase());
  return false;
};

const isInactiveStatus = (value) => {
  if (value === false || value === 0) return true;
  if (typeof value === "string") return inactiveStatusValues.includes(value.trim().toLowerCase());
  return false;
};

const isDriverAccountApproved = (user) => !!(
  user && (isTruthyStatus(user.approved) || isTruthyStatus(user.adminApprovedTrue))
);

const isDriverAccountBlocked = (user) => !!(
  user && (
    isTruthyStatus(user.blocked) ||
    isTruthyStatus(user.suspended) ||
    isTruthyStatus(user.deleted)
  )
);

const isDriverAccountEnabled = (user) => {
  if (!user || isDriverAccountBlocked(user)) return false;
  return isTruthyStatus(user.active) && !isInactiveStatus(user.active);
};

const isDriverOnDuty = (user) => isTruthyStatus(user && user.driverActiveStatus);

export const fetchUsers = () => (dispatch) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_DRIVERS,
    payload: null
  });
  onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);
      const locations = locationdata.val();
      const data = snapshot.val();
      const arr = Object.keys(data)
      .filter(i => data[i].usertype!='admin')
      .map(i => {
        data[i].id = i;
        data[i].location = locations && locations[i] ? locations[i] : null;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_ALL_USERS_FAILED,
        payload: "No users available."
      });
    }
  });
};


export const fetchUsersOnce = () => (dispatch) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_USERS_STATIC,
    payload: null
  });
  onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);
      const locations = locationdata.val();
      const data = snapshot.val();
      const arr = Object.keys(data)
      .map(i => {
        data[i].id = i;
        data[i].location = locations && locations[i] ? locations[i] : null;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_STATIC_SUCCESS,
        payload: arr
      })
    } else {
      dispatch({
        type: FETCH_ALL_USERS_STATIC_FAILED,
        payload: "No users available."
      });
    }
  },{onlyOnce: true});
  
};
export const clearFetchDrivers = () => (dispatch) => {
  const {
    driversRef,
    allLocationsRef,
  } = firebase;
  off(driversRef);
  off(allLocationsRef);
}

export const fetchDrivers = (appType) => async(dispatch) => {

  const {
    driversRef,
    allLocationsRef,
    settingsRef,
  } = firebase;

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null
  });

  onValue(driversRef, snapshot => {
    if (snapshot.val()) {
      onValue(allLocationsRef, locres=>{
        const locations = locres.val();
          const data = snapshot.val();
          const arr = Object.keys(data)
          .filter(i => data && isDriverAccountApproved(data[i]) && isDriverAccountEnabled(data[i]) && isDriverOnDuty(data[i]) && !isDriverAccountBlocked(data[i]) && locations && locations[i] && ( (data[i].licenseImage && settings.license_image_required) || !settings.license_image_required)
                      && (((isTruthyStatus(data[i].carApproved) && settings.carType_required) || !settings.carType_required) || !settings.carType_required) && ((isTruthyStatus(data[i].term) && settings.term_required) || !settings.term_required) ) 
          .map(i => {
            return {
              id: i,
              location: locations && locations[i] ? locations[i]:null,
              carType: data[i].carType ? data[i].carType : null,
              vehicleNumber:  data[i].vehicleNumber ? data[i].vehicleNumber : null,
              fleetadmin:  data[i].fleetadmin ? data[i].fleetadmin : null,
              firstName: data[i].firstName,
              lastName: data[i].lastName,
              queue: data[i].queue
            };
          });
          dispatch({
            type: FETCH_ALL_DRIVERS_SUCCESS,
            payload: arr
          });
        }, appType === 'app' ? {onlyOnce: true} : settings && settings.realtime_drivers ? null : {onlyOnce: true})
    } else {
      dispatch({
        type: FETCH_ALL_DRIVERS_FAILED,
        payload: "No users available."
      });
    }
  },appType === 'app'? {onlyOnce: true}: settings && settings.realtime_drivers ? null : {onlyOnce: true});
};

export const addUser = (userdata) => (dispatch) => {
  const {
    usersRef
  } = firebase;

  const finalUserData =
    String(userdata?.usertype || "").toLowerCase() === "driver"
      ? {
          ...userdata,
          active: userdata.active !== false,
          driverActiveStatus: false,
          queue: false,
          authProvisioningStatus:
            userdata.authProvisioningStatus || "not_invited",
          adminApprovedTrue:
            userdata.adminApprovedTrue === true ||
            userdata.approved === true
        }
      : userdata;

  dispatch({
    type: EDIT_USER,
    payload: finalUserData
  });

  delete finalUserData.tableData;

  push(usersRef, finalUserData).then(() => {
    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error
    });
  });
}

export const sendFleetAdminDriverInvite = (driverId) => async (dispatch) => {
  const { auth, config } = firebase;
  if (!driverId) {
    throw new Error('Driver ID is required.');
  }
  if (!auth.currentUser) {
    throw new Error('Authentication is required.');
  }

  const token = await auth.currentUser.getIdToken();
  const response = await fetch(firebase.functionUrl ? firebase.functionUrl('fleet_admin_send_driver_invite') : `https://us-central1-${config.projectId}.cloudfunctions.net/fleet_admin_send_driver_invite`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ driverId })
  });
  let result = {};
  try {
    result = await response.json();
  } catch (error) {
    throw new Error('Invalid response from the driver invitation service.');
  }
  if (!response.ok || result.error) {
    throw new Error(result.error || 'Failed to send the driver invitation.');
  }
  dispatch(fetchUsersOnce());
  return result;
};

const normalizeClientEmail = (value) => value ? value.toString().trim().toLowerCase() : '';

const normalizeClientMobile = (value) => value ? value.toString().replace(/[^0-9]/g, '') : '';

const fleetAdminsContains = (fleetadmins, fleetAdminUid) => {
  if (!fleetadmins || !fleetAdminUid) return false;
  if (Array.isArray(fleetadmins)) {
    return fleetadmins.some((value) => `${value}` === `${fleetAdminUid}`);
  }
  if (typeof fleetadmins === 'object') {
    return !!fleetadmins[fleetAdminUid];
  }
  return `${fleetadmins}` === `${fleetAdminUid}`;
};

const getFleetAdminsMap = (customer) => {
  const result = {};
  const existing = customer && customer.fleetadmins;
  if (Array.isArray(existing)) {
    existing.forEach((uid) => {
      if (uid) result[uid] = true;
    });
  } else if (existing && typeof existing === 'object') {
    Object.keys(existing).forEach((uid) => {
      if (existing[uid]) result[uid] = true;
    });
  } else if (existing) {
    result[existing] = true;
  }
  if (customer && customer.fleetadmin) result[customer.fleetadmin] = true;
  return result;
};

const relationshipFunctionUrl = () => {
  const { config } = firebase;
  if (!config || !config.projectId) {
    throw new Error('Firebase projectId is required for client relationship creation.');
  }
  return firebase.functionUrl ? firebase.functionUrl('hybrid_create_or_get_organization_client_relationship') : 'https://us-central1-' + config.projectId + '.cloudfunctions.net/hybrid_create_or_get_organization_client_relationship';
};

const callOrganizationClientRelationship = async (payload) => {
  const { auth } = firebase;
  if (!auth.currentUser) throw new Error('Authentication is required.');
  const token = await auth.currentUser.getIdToken();
  const response = await fetch(relationshipFunctionUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify(payload)
  });
  let result = {};
  try {
    result = await response.json();
  } catch (error) {
    throw new Error('Invalid response from the client relationship service.');
  }
  if (!response.ok || result.error) {
    throw new Error(result.error || 'Failed to create client relationship.');
  }
  return result;
};

const relationshipResultToClient = (result, fallbackData = {}, extra = {}) => {
  const relationship = result.relationship || {};
  const relationshipId = result.relationshipId || relationship.relationshipId;
  const clientAuthUid = result.clientAuthUid || relationship.clientAuthUid || null;
  return {
    ...fallbackData,
    ...relationship,
    id: relationshipId,
    uid: clientAuthUid || relationshipId,
    customerUid: clientAuthUid,
    clientAuthUid,
    globalClientNumber: result.globalClientNumber || relationship.globalClientNumber || null,
    organizationId: result.organizationId || relationship.organizationId || null,
    organizationClientRelationshipId: relationshipId,
    organizationClientNumber: result.organizationClientNumber || relationship.organizationClientNumber || null,
    loginStatus: relationship.loginStatus || (clientAuthUid ? 'LINKED' : 'NO_ACCOUNT'),
    reusedExisting: result.decision === 'USE_EXISTING',
    relationshipCreated: result.created === true,
    relationshipAlreadyExisted: result.created === false && result.decision === 'USE_EXISTING',
    duplicateScope: extra.duplicateScope || null
  };
};

export const addFleetAdminClient = (clientData) => async (dispatch) => {
  const { usersRef, singleUserRef, auth } = firebase;
  const profile = store.getState().auth.profile || {};
  const fleetAdminUid = profile.uid || (auth.currentUser && auth.currentUser.uid);
  if (!fleetAdminUid || profile.usertype !== 'fleetadmin') {
    throw new Error('Only Fleet Admin can create a private booking client.');
  }

  const clientName = clientData && clientData.clientName ? clientData.clientName.toString().trim() : '';
  const clientContact = clientData && clientData.clientContact ? clientData.clientContact.toString().trim() : '';
  const clientEmail = clientData && clientData.clientEmail ? clientData.clientEmail.toString().trim() : '';
  const clientAddress = clientData && clientData.clientAddress ? clientData.clientAddress.toString().trim() : '';
  const companyName = clientData && clientData.companyName ? clientData.companyName.toString().trim() : '';
  const companyAddress = clientData && clientData.companyAddress ? clientData.companyAddress.toString().trim() : clientAddress;
  const telephoneNumber = clientData && clientData.telephoneNumber ? clientData.telephoneNumber.toString().trim() : '';
  if (!clientName || !clientContact) {
    throw new Error('Client name and contact are required.');
  }

  const nameParts = clientName.split(/\s+/);
  const firstName = clientData && clientData.firstName ? clientData.firstName.toString().trim() : (nameParts.shift() || clientName);
  const lastName = clientData && clientData.lastName ? clientData.lastName.toString().trim() : nameParts.join(' ');
  const normalizedEmail = normalizeClientEmail(clientEmail);
  const normalizedMobile = normalizeClientMobile(clientContact);
  const usersSnapshot = await get(usersRef);
  const users = usersSnapshot.exists() ? usersSnapshot.val() : {};
  const duplicateMatches = Object.keys(users).filter((id) => {
    const customer = users[id];
    if (!customer || customer.usertype !== 'customer') return false;
    const existingEmail = normalizeClientEmail(customer.normalizedEmail || customer.clientEmail || customer.email);
    const existingMobile = normalizeClientMobile(customer.normalizedMobile || customer.clientContact || customer.mobile);
    const emailMatches = !!normalizedEmail && !!existingEmail && normalizedEmail === existingEmail;
    const mobileMatches = !!normalizedMobile && !!existingMobile && normalizedMobile === existingMobile;
    return emailMatches || mobileMatches;
  });

  if (duplicateMatches.length > 1) {
    throw new Error('The entered email or contact matches multiple customer records. Please select the existing client instead.');
  }

  if (duplicateMatches.length === 1) {
    const existingId = duplicateMatches[0];
    const existingCustomer = users[existingId];
    const isSameFleetAdmin = existingCustomer.fleetadmin === fleetAdminUid ||
      existingCustomer.createdBy === fleetAdminUid ||
      fleetAdminsContains(existingCustomer.fleetadmins, fleetAdminUid);
    const explicitExistingUid = clientData && (
      clientData.clientAuthUid || clientData.existingClientAuthUid ||
      clientData.selectedClientAuthUid || clientData.globalClientAuthUid ||
      clientData.existingClientId
    );
    const decision = explicitExistingUid ? 'USE_EXISTING' : 'CREATE_SEPARATE';
    const relationshipResult = await callOrganizationClientRelationship({
      decision,
      clientAuthUid: explicitExistingUid || undefined,
      existingClientAuthUid: explicitExistingUid || undefined,
      clientData: {
        clientName,
        firstName,
        lastName,
        clientContact,
        clientEmail: normalizedEmail,
        clientAddress: clientAddress || companyAddress,
        companyName,
        companyAddress,
        telephoneNumber
      }
    });
    const fallbackClient = decision === 'USE_EXISTING'
      ? { ...existingCustomer, id: existingId, uid: existingId }
      : {
          usertype: 'customer',
          firstName,
          lastName,
          mobile: clientContact,
          email: normalizedEmail,
          clientName,
          clientContact,
          clientEmail: normalizedEmail,
          clientAddress: clientAddress || companyAddress,
          companyName,
          companyAddress,
          telephoneNumber,
          normalizedEmail,
          normalizedMobile
        };
    const reusedClient = relationshipResultToClient(relationshipResult, fallbackClient, {
      duplicateScope: isSameFleetAdmin ? 'same_fleetadmin' : 'global'
    });
    dispatch({ type: EDIT_USER_SUCCESS, payload: null });
    return reusedClient;
  }

  const createdClient = {
    usertype: 'customer',
    firstName,
    lastName,
    mobile: clientContact,
    email: normalizedEmail,
    clientName,
    clientContact,
    clientEmail: normalizedEmail,
    clientAddress: clientAddress || companyAddress,
    companyName,
    companyAddress,
    telephoneNumber,
    normalizedEmail,
    normalizedMobile,
    createdByRole: 'fleetadmin',
    createdBy: fleetAdminUid,
    fleetadmin: fleetAdminUid,
    fleetadmins: { [fleetAdminUid]: true },
    organizationId: profile.organizationId || fleetAdminUid,
    organizationName: profile.companyName,
    organizationType: 'Logistics Company',
    fleetAdminUid: fleetAdminUid,
    loginStatus: 'NO_ACCOUNT',
    relationshipStatus: 'ACTIVE',
    active: true,
    walletBalance: 0,
    createdAt: new Date().getTime()
  };

  dispatch({ type: EDIT_USER, payload: createdClient });
  try {
    const relationshipResult = await callOrganizationClientRelationship({
      decision: clientData && clientData.relationshipDecision === 'CANCEL' ? 'CANCEL' : 'CREATE_SEPARATE',
      clientData: createdClient
    });
    const result = relationshipResult.cancelled
      ? { ...createdClient, id: null, uid: null, cancelled: true }
      : relationshipResultToClient(relationshipResult, createdClient);
    dispatch({ type: EDIT_USER_SUCCESS, payload: null });
    return result;
  } catch (error) {
    dispatch({ type: EDIT_USER_FAILED, payload: error });
    throw error;
  }

};

export const editUser = (id, user) => (dispatch) => {

  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: user
  });
  let editedUser = { ...user };
  delete editedUser.id;
  delete editedUser.tableData;
  return set(singleUserRef(id), editedUser)
    .then(() => {
      dispatch({
        type: EDIT_USER_SUCCESS,
        payload: user
      });
      return user;
    })
    .catch((error) => {
      dispatch({
        type: EDIT_USER_FAILED,
        payload: error
      });
      throw error;
    });
}

export const updateUserCar = (id, data) => (dispatch) => {
  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: data  
  });
  update(singleUserRef(id),data);
}

export const updateLicenseImage = (uid, imageBlob, imageType) => async (dispatch) => {

  const {
    singleUserRef,
    driverDocsRef,
    driverDocsRefBack,
    verifyIdImageRef
  } = firebase;

  let profile = {};
  if(imageType === 'licenseImage'){
    await uploadBytesResumable(driverDocsRef(uid),imageBlob);
    let image = await getDownloadURL(driverDocsRef(uid));
    profile.licenseImage = image;
  }
  if(imageType === 'licenseImageBack'){
    await uploadBytesResumable(driverDocsRefBack(uid),imageBlob);
    let image1 = await getDownloadURL(driverDocsRefBack(uid));
    profile.licenseImageBack = image1;
  }
  if(imageType === 'verifyIdImage'){
    await uploadBytesResumable(verifyIdImageRef(uid),imageBlob);
    let image1 = await getDownloadURL(verifyIdImageRef(uid));
    profile.verifyIdImage = image1;
  }
  update(singleUserRef(uid),profile);
  dispatch({
    type: EDIT_USER,
    payload: uid
  });
};

export const deleteUser = (uid) => (dispatch) => {

  const {
    auth,
    walletHistoryRef,
    singleUserRef,
    userNotificationsRef,
    carsRef,
    carEditRef
  } = firebase;

  dispatch({
    type: DELETE_USER,
    payload: uid
  });

  if (auth.currentUser.uid === uid) {
    off(singleUserRef(uid));
    off(walletHistoryRef(uid));
    off(userNotificationsRef(uid));
  }

  onValue(singleUserRef(uid), userdata => {
    const profile = userdata.val();
    if(profile.usertype === 'driver'){
      onValue(carsRef(uid, profile.usertype), carssnapshot => {
        let cars = carssnapshot.val();
        if (cars) {
          const arr = Object.keys(cars);
          for(let i = 0; i < arr.length; i++){
            remove(carEditRef(arr[i]));
          }
        }
      });
    } 
    
    remove(singleUserRef(uid)).then(() => {
      if (auth.currentUser.uid === uid) {
        signOut(auth);
        dispatch({
          type: USER_DELETED,
          payload: null
        });
      } else {
        remove(singleUserRef(uid)).then(() => {
          dispatch({
            type: DELETE_USER_SUCCESS,
            payload: null
          });
        }).catch((error) => {
          dispatch({
            type: DELETE_USER_FAILED,
            payload: error
          });
        });
      }
    });
  },{onlyOnce:true});
}
